// mintedGhost.ts — GHOST DUELS (Slice B) session stash for the daily ghost this session uploaded.
//
// Uploading is OPT-IN and happens at the daily leaderboard submit (leaderboardPanel.ts). On success we
// stash the returned KV id here so the NEXT share from ResultScene can mint `&gr=<id>` into the link — a
// friend then fetches + races the actual replay instead of only the static footprints. Session-scoped
// module state (NO storage, NO PII): a fresh page load has no minted id until the player submits a named
// daily score again. Keyed by the run's identity (day+seed+topic) so a share only carries the id for the
// exact daily run it was minted for (a non-daily / different-day share never leaks it).

interface MintedGhost {
  id: string;
  day: string;
  seed: number;
  topic: string;
}

let minted: MintedGhost | null = null;

/** Record the id of the ghost just uploaded for a specific daily run. */
export function setMintedGhost(m: MintedGhost): void {
  minted = m;
}

/**
 * The minted id for THIS exact run, or '' if none matches. Matching on day+seed+topic guarantees the id is
 * only attached to a share of the same daily board it was uploaded from.
 */
export function getMintedGhostId(day: string, seed: number, topic: string): string {
  if (minted && minted.day === day && minted.seed === seed && minted.topic === topic) return minted.id;
  return '';
}
